export default __webpack_public_path__ + "static/media/exam-record-card-mark.b0329bb1.svg";